export default __webpack_public_path__ + "media/circle-shape.ac666fad.svg";